/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function () {

    function selectLargeVariant() {
      // Target only Size radio buttons
      const sizeRadios = document.querySelectorAll('input[type="radio"][name^="Size"]');
      let largeFound = false;
      sizeRadios.forEach(function(input) {
        const valueText = input.value.trim().toLowerCase();
        // Match "large" but avoid matching "xlarge"
        if (
          valueText.includes("large") &&
          !valueText.includes("xlarge")
        ) {
          input.checked = true;
          input.dispatchEvent(new Event("change", { bubbles: true }));
          largeFound = true;
        }
      });

      // Fallback for dropdowns (if any)
      const sizeSelects = document.querySelectorAll('select[name^="Size"]');
      sizeSelects.forEach(function(select) {
        for (let i = 0; i < select.options.length; i++) {
          const optionText = select.options[i].text.toLowerCase();
          if (
            optionText.includes("large") &&
            !optionText.includes("xlarge")
          ) {
            select.selectedIndex = i;
            select.dispatchEvent(new Event("change", { bubbles: true }));
            break;
          }
        }
      });
    }

    selectLargeVariant();
    
    document.addEventListener("shopify:section:load", function () {
      selectLargeVariant();
    });

  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
